import { Class } from "core/Abacus.Utilities";
import { Promise } from "es6-promise-polyfill";
import Cookies from "js-cookie";
import { getDataLayerVal } from "utils/datalayerextraction";

$(function() {
  new IPMessaging(this);
});

let IPMessagingOptions = {
  cookie: "IP_Message_Accepted"
};

class IPMessaging extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(IPMessagingOptions, options);
    this.setUpEvents();
  }

  setUpEvents() {
    var self = this;

    this.options.isLoggedOn = getDataLayerVal("LoggedIn"); //true or false

    if (this.options.isLoggedOn === "True") {
      this.options.divName = ".ip-loggedin";
    } else {
      this.options.divName = ".ip-loggedout";
    }

    this.options.ipState = IPState.useripstate;
    this.options.companyName = IPState.useripname;

    if (this.options.ipState) {
      this.getIPMessage();
      $("body").on("click", ".message-close", function(evt) {
        self.hideMessage(this);
      });
      $("body").on("keyup", ".message-close", function(evt) {
        if (evt.keyCode && evt.keyCode == "13") self.hideMessage(this);
      });
    }
  }

  hideMessage(context) {
    this.writeCookie();
    $(context)
      .parents(".ip-messaging--message")
      .addClass("hide");
  }

  getIPMessage() {
    var self = this;

    let message = new Promise(function(resolve, reject) {
      $.ajax({
        url:
          "/ipmessageblocktext?companyname=" +
          encodeURIComponent(self.options.companyName),
        success: (data, textStatus, jqXHR) => resolve(data),
        error: jqr => reject(jqr)
      });
    });

    message
      .then(data => {
        let messageHeader = $(data).find(".ip-messaging--header"),
          messageContent = $(data).find(self.options.divName);

        $(messageHeader).insertBefore(".mast");
        if (self.readCookie(self.options.cookie) === "true") return;
        $(messageContent).appendTo("#masthead");
      })
      .catch(d => {
        console.warn(d.status);
      });
  }

  writeCookie() {
    Cookies.set(this.options.cookie, true, {
      path: "/"
    });
  }

  readCookie(name) {
    return Cookies.get(name);
  }
}

export { IPMessaging };



// WEBPACK FOOTER //
// ./Javascript/core/classes/ipmessaging.class.js